import { useState, useEffect } from 'react';
import { Package, Truck, Search, Eye, ExternalLink, CheckCircle2, AlertCircle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './Orders.css';

export default function Orders() {
  const { API_BASE, token } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [updatingAwb, setUpdatingAwb] = useState(null); // ID of order being updated
  const [awbValue, setAwbValue] = useState('');

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    try {
      const res = await fetch(`${API_BASE}/orders/all`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      setOrders(data);
    } catch (err) {
      console.error('Fetch orders error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateAwb = async (id) => {
    if (!awbValue) return;
    try {
      const res = await fetch(`${API_BASE}/orders/${id}/awb`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ awb_code: awbValue })
      });
      if (res.ok) {
        alert('AWB Updated and Order marked as Shipped!');
        setUpdatingAwb(null);
        setAwbValue('');
        fetchOrders();
      }
    } catch (err) {
      alert('Failed to update AWB');
    }
  };

  const filtered = orders.filter(o => 
    o.orderId.toLowerCase().includes(search.toLowerCase()) || 
    o.shippingAddress.firstName.toLowerCase().includes(search.toLowerCase()) ||
    o.shippingAddress.phone.includes(search)
  );

  return (
    <div className="admin-orders">
      <div className="admin-page-header">
        <div>
          <h1 className="admin-page-title">Order Management</h1>
          <p className="admin-page-sub">Track and sync orders with Shiprocket AWB</p>
        </div>
      </div>

      <div className="admin-card">
        <div className="featured-search-bar" style={{ marginBottom: 20 }}>
          <Search size={16} />
          <input 
            type="text" 
            placeholder="Search by Order ID, Name or Mobile..." 
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        <div className="dash-table-wrap">
          <table className="dash-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Customer</th>
                <th>Items</th>
                <th>Total</th>
                <th>Status</th>
                <th>Shiprocket AWB</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr><td colSpan="7" style={{ textAlign: 'center', padding: 40 }}>Loading orders...</td></tr>
              ) : filtered.map(o => (
                <tr key={o._id}>
                  <td>
                    <p style={{ fontWeight: 700, fontSize: 13 }}>{o.orderId}</p>
                    <p style={{ fontSize: 11, color: '#666' }}>{new Date(o.createdAt).toLocaleString()}</p>
                  </td>
                  <td>
                    <p style={{ fontWeight: 600 }}>{o.shippingAddress.firstName}</p>
                    <p style={{ fontSize: 11 }}>{o.shippingAddress.phone}</p>
                  </td>
                  <td>{o.items.length} items</td>
                  <td style={{ fontWeight: 700 }}>₹{o.totals.total}</td>
                  <td>
                    <span className={`status-badge status-${o.status}`}>
                      {o.status}
                    </span>
                  </td>
                  <td>
                    {updatingAwb === o._id ? (
                      <div className="awb-edit-row">
                        <input 
                          type="text" 
                          placeholder="Enter AWB" 
                          value={awbValue}
                          onChange={e => setAwbValue(e.target.value)}
                        />
                        <button className="admin-btn-sm btn-save" onClick={() => handleUpdateAwb(o._id)}>Save</button>
                        <button className="admin-btn-sm btn-cancel" onClick={() => setUpdatingAwb(null)}>×</button>
                      </div>
                    ) : (
                      <div className="awb-display">
                        {o.awb_code ? (
                          <span className="awb-code-pill">{o.awb_code}</span>
                        ) : (
                          <button className="admin-btn-secondary admin-btn-sm" onClick={() => setUpdatingAwb(o._id)}>
                            + Add AWB
                          </button>
                        )}
                      </div>
                    )}
                  </td>
                  <td>
                    <a href={`/track-order?id=${o.orderId}`} target="_blank" rel="noreferrer" className="admin-btn-sm">
                      <Eye size={14} /> View
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
